/*
 * Copyright (c) 2025 Sila Artificial Intelligence Research LLC
 * A DA Holding Ltd Company
 * All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 */

export interface User {
  email?: string;
  name?: string;
  picture?: string;
  sub: string;
}

const mockUser: User = {
  email: 'demo@brandhealth360.com',
  name: 'Demo User',
  picture: null,
  sub: 'demo_user_123'
};

/**
 * Simple auth hook that returns a mock user.
 * Authentication has been removed - all users are treated as authenticated.
 */
export const useAuth = () => {
  return {
    isAuthenticated: true,
    isLoading: false,
    user: mockUser,
    login: () => console.log('Auth disabled'),
    logout: () => console.log('Auth disabled'),
    getToken: async () => 'no_auth_token',
    error: null,
  };
};

export default useAuth;
